module.exports = __webpack_public_path__ + "img/tile-and-ceramic.61576d19.jpg";